import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import CreaInformacionLiderSolocitud from "../Modals/crear/CreaInformacionLiderSolicitud";
import { obtenerLiderSolicitudes } from "../../Services/Rest";
import Cookies from "universal-cookie";

function InfoLiderSolicitud(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerLiderSolicitudesPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <Fragment>
      <div className="text-center">
        <div class="container-fluid">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">
                INFORMACIÓN LIDER
              </h6>
            </div>
            <div class="card-body">
              {cookies.get("tipo_Usuario") == 2 ? (
                <CreaInformacionLiderSolocitud
                  idSolicitud={props.idSolicitud}
                />
              ) : (
                <h1></h1>
              )}

              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Nombre</th>
                      <th>Cargo</th>
                      <th>Telefono</th>
                      <th>Celular</th>
                      <th>Departamento</th>
                      <th>municipio</th>
                      <th>Direccion</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.nombre}</td>
                          <td>{item.cargo}</td>
                          <td>{item.telefono}</td>
                          <td>{item.celular}</td>
                          <td>{item.departamento}</td>
                          <td>{item.ciudad}</td>
                          <td>{item.direccion}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoLiderSolicitud;
